// exploratoryReading (0157): the Review page's ONE home of the lines that say
// what the engine did with a founder's answer - why a playback came back after
// a reject (founder ruling F4), how to fix a held-back misread in one save
// (founder ruling Q3, shortened by Q12), and which proposed decision a saved
// changed answer will replace (founder ruling Q8). Every line is fixed UI text
// in the founder's ruled words (the founder may reword any of them later; a
// reworded string changes only the string), and each renders only on state the
// engine writes (fields.answer_reading, fields.deferral_of) or the decisions
// queue serves (replaced_by_new_answer_node_ids). Nothing here calls the
// engine, and nothing here infers a state the engine did not write.

// The prior rejection a reopened question's reading records (the engine's
// fields.answer_reading.prior_rejection, written when the founder's reject of a
// decision minted from the answer was applied): the rejected decision's id and
// title, and the founder's reason, as stored ("" for a key that is absent or
// not a string).
export type ReopenedRecord = { decisionId: string; decisionTitle: string; reason: string };

function asRecord(v: unknown): Record<string, unknown> | undefined {
  return typeof v === "object" && v !== null && !Array.isArray(v) ? (v as Record<string, unknown>) : undefined;
}

function asText(v: unknown): string {
  return typeof v === "string" ? v : "";
}

// readReopenedRecord is the reopened question's record, or null: non-null only
// when fields.answer_reading is an object whose disposition is "reopened" and
// whose prior_rejection.reason is non-blank after trim. Every other reading (a
// settles or defers reading, a reopened one with no reason, a missing or
// malformed field) is null, so no line renders on it.
export function readReopenedRecord(fields: Record<string, unknown>): ReopenedRecord | null {
  const reading = asRecord(fields.answer_reading);
  if (reading === undefined || reading.disposition !== "reopened") return null;
  const prior = asRecord(reading.prior_rejection);
  if (prior === undefined) return null;
  const reason = asText(prior.reason);
  if (reason.trim() === "") return null;
  return { decisionId: asText(prior.decision_id), decisionTitle: asText(prior.decision_title), reason };
}

// reopenedReadingLine is founder ruling F4's line on a reopened question, shown
// above its prefilled answer: the decision title the founder turned down and
// the reason they gave, then where their position belongs.
export function reopenedReadingLine(title: string, reason: string): string {
  return `You turned down our reading, '${title}', saying: '${reason}'. Put your position in the answer itself. That's what we build from.`;
}

// isJudgedTargetDeferral is true exactly when fields.deferral_of is an object
// whose part is "target": a decision the engine minted from the part of the
// founder's own answer the judge read as held back. A side deferral, a decision
// with no stamp and a malformed stamp are all false.
export function isJudgedTargetDeferral(fields: Record<string, unknown>): boolean {
  const stamp = asRecord(fields.deferral_of);
  return stamp !== undefined && stamp.part === "target";
}

// JUDGED_DEFERRAL_HINT is founder ruling Q3's hint as shortened by Q12, shown on
// a proposed decision isJudgedTargetDeferral names (unless the decisions queue
// serves it as replaced by a new answer, founder ruling Q15).
export const JUDGED_DEFERRAL_HINT =
  "We read your answer as holding this back for now. If that's wrong, put your position in the answer.";

// REPLACED_BY_NEW_ANSWER_HINT is founder ruling Q8's line, shown on a decision
// the decisions queue serves in replaced_by_new_answer_node_ids (0157-15): the
// server's list decides, and it is never inferred here.
export const REPLACED_BY_NEW_ANSWER_HINT = "Your new answer will replace this.";
